import { queryKeys } from "../queryKeys";
import { type BillingPlans, getBillingPlans } from "../rest/billing";
import useRequest, { type QueryOptions } from "./useRequest";

export const useGetBillingPlans = ({
  options,
}: {
  options?: QueryOptions<BillingPlans>;
} = {}) => {
  const { data: plans, ...rest } = useRequest(
    queryKeys.billing.plans(),
    getBillingPlans,
    {
      ...options,
    },
  );

  return {
    plans,
    ...rest,
  };
};
